import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { AddressDetails } from "../smart-components/smart-component-property";

/**
 * This class handle properties of blind
 */
export class ComponentAdaperBlind
  extends ComponentAdapterParent
  implements IComponentLoader
{
  private _openCommand: AddressDetails = null;
  private _closeCommand: AddressDetails = null;
  private _stopCommand: AddressDetails = null;
  private _heightState: AddressDetails = null;
  private _heightCommand: AddressDetails = null;
  private _slatPositionCommand: AddressDetails = null;
  private _slatPositionState: AddressDetails = null;
  private _slatPositionCommandMin: string = null;
  private _slatPositionCommandMax: string = null;

  /**
   * Get the open command address
   */
  get OpenCommand(): AddressDetails {
    return this._openCommand;
  }

  /**
   * Get the slat position command address
   */
  get SlatPositionCommand(): AddressDetails {
    return this._slatPositionCommand;
  }

  /**
   * Get the slat position state
   */
  get SlatPositionState(): AddressDetails {
    return this._slatPositionState;
  }

  /**
   * Get the slat position command min
   */
  get SlatPositionCommandMin(): string {
    return this._slatPositionCommandMin;
  }

  /**
   * Get the slat position command max
   */
  get SlatPositionCommandMax(): string {
    return this._slatPositionCommandMax;
  }

  /**
   * Get the close command address
   */
  get CloseCommand(): AddressDetails {
    return this._closeCommand;
  }

  /**
   * Get the stop command address
   */
  get StopCommand(): AddressDetails {
    return this._stopCommand;
  }

  /**
   * Get the height state address
   */
  get HeightState(): AddressDetails {
    return this._heightState;
  }

  /**
   * Get the open command address
   */
  get HeightCommand(): AddressDetails {
    return this._heightCommand;
  }

  constructor() {
    super();
  }

  public fillProperty(
    listSmartComponentSkills: Array<SmartComponentPropertyDetails>
  ): void {
    this._name =
      listSmartComponentSkills.find(
        (titleSkill) => titleSkill.titleSkill === SkillNameList.BLIND_NAME
      )?.value || "";
    this._description =
      listSmartComponentSkills.find(
        (descriptionSkill) =>
          descriptionSkill.titleSkill === SkillNameList.BLIND_DESCRIPTION
      )?.value || "";
    this._openCommand =
      listSmartComponentSkills.find(
        (openCommandSkill) =>
          openCommandSkill.titleSkill === SkillNameList.BLIND_COMMAND_OPEN
      )?.address || null;
    this._closeCommand =
      listSmartComponentSkills.find(
        (closeCommandSkill) =>
          closeCommandSkill.titleSkill === SkillNameList.BLIND_COMMAND_CLOSE
      )?.address || null;
    this._stopCommand =
      listSmartComponentSkills.find(
        (stopCommandSkill) =>
          stopCommandSkill.titleSkill === SkillNameList.BLIND_COMMAND_STOP
      )?.address || null;
    this._heightState =
      listSmartComponentSkills.find(
        (heightStateSkill) =>
          heightStateSkill.titleSkill === SkillNameList.BLIND_STATE_HEIGHT
      )?.address || null;
    this._heightCommand =
      listSmartComponentSkills.find(
        (heightStateSkill) =>
          heightStateSkill.titleSkill === SkillNameList.BLIND_COMMAND_HEIGHT
      )?.address || null;
    this._slatPositionCommand =
      listSmartComponentSkills.find(
        (slatPositionCommandSkill) =>
          slatPositionCommandSkill.titleSkill ===
          SkillNameList.SLAT_POSITION_COMMAND
      )?.address || null;
    this._slatPositionState =
      listSmartComponentSkills.find(
        (slatPositionStateSkill) =>
          slatPositionStateSkill.titleSkill ===
          SkillNameList.SLAT_POSIITION_STATE
      )?.address || null;
    this._slatPositionCommandMin =
      listSmartComponentSkills.find(
        (slatPositionCommandMinSkill) =>
          slatPositionCommandMinSkill.titleSkill ===
          SkillNameList.SLAT_POSITION_COMMAND_MIN
      )?.value || null;
    this._slatPositionCommandMax =
      listSmartComponentSkills.find(
        (slatPositionCommandMaxSkill) =>
          slatPositionCommandMaxSkill.titleSkill ===
          SkillNameList.SLAT_POSITION_COMMAND_MAX
      )?.value || null;
    this.fillMissingProperty();
    this.fillAddressState();
  }

  public fillMissingProperty(): void {
    if (this._closeCommand === null && this._openCommand !== null) {
      this._closeCommand = this._openCommand;
    }

    if (this._closeCommand !== null && this._openCommand === null) {
      this._openCommand = this._closeCommand;
    }

    if (this._heightCommand !== null && this._heightState === null) {
      this._heightState = this._heightCommand;
    }
  }

  public fillAddressState(): void {
    if (this._heightState !== null) {
      this._listSubscribeAddress.push(this._heightState);
    }
    if (this._slatPositionState !== null) {
      this._listSubscribeAddress.push(this._slatPositionState);
    }
  }
}
